module.exports = __webpack_public_path__ + "img/CAJA.bb7a6de0.jpeg";